import React, { useState } from 'react';
import './MembersPage.css';
import { AiFillHome } from 'react-icons/ai';
import { MdRestaurantMenu } from 'react-icons/md';
import { FaMoneyBillWave, FaUserFriends, FaGift } from 'react-icons/fa';
import { GiKnifeFork } from 'react-icons/gi';

const navItems = [
  'Home',
  'Product',
  'Sales',
  'Members',
  'Promotion',
  'Restaurant',
];

const navIcons = {
  Home: <AiFillHome className="nav-icon" />,
  Product: <MdRestaurantMenu className="nav-icon" />,
  Sales: <FaMoneyBillWave className="nav-icon" />,
  Members: <FaUserFriends className="nav-icon" />,
  Promotion: <FaGift className="nav-icon" />,
  Restaurant: <GiKnifeFork className="nav-icon" />,
};

const initialMembers = [
  {
    id: 1,
    email: 'admin@restaurant.com',
    phone: '+86 138 0013 8000',
    points: 2500,
    membershipTier: 'platinum',
    role: 'admin',
    status: 'active',
    joinDate: '2023-01-15'
  },
  {
    id: 2,
    email: 'zhang.wei@email.com',
    phone: '+86 139 0024 9001',
    points: 1800,
    membershipTier: 'gold',
    role: 'member',
    status: 'active',
    joinDate: '2023-03-22'
  },
  {
    id: 3,
    email: 'li.ming@email.com',
    phone: '+86 137 0035 1002',
    points: 950,
    membershipTier: 'silver',
    role: 'member',
    status: 'active',
    joinDate: '2023-05-10'
  },
  {
    id: 4,
    email: 'wang.fang@email.com',
    phone: '+86 136 0046 2003',
    points: 420,
    membershipTier: 'basic',
    role: 'member',
    status: 'inactive',
    joinDate: '2023-07-08'
  },
  {
    id: 5,
    email: 'chen.lei@email.com',
    phone: '+86 135 0057 3004',
    points: 1200,
    membershipTier: 'gold',
    role: 'member',
    status: 'active',
    joinDate: '2023-09-15'
  },
  {
    id: 6,
    email: 'liu.hong@email.com',
    phone: '+86 134 0068 4005',
    points: 680,
    membershipTier: 'silver',
    role: 'member',
    status: 'active',
    joinDate: '2023-11-03'
  },
  {
    id: 7,
    email: 'zhao.min@email.com',
    phone: '+86 133 0079 5006',
    points: 3200,
    membershipTier: 'platinum',
    role: 'member',
    status: 'active',
    joinDate: '2023-02-14'
  },
  {
    id: 8,
    email: 'sun.li@email.com',
    phone: '+86 132 0080 6007',
    points: 750,
    membershipTier: 'silver',
    role: 'member',
    status: 'active',
    joinDate: '2023-04-05'
  },
  {
    id: 9,
    email: 'wu.jun@email.com',
    phone: '+86 131 0091 7008',
    points: 1500,
    membershipTier: 'gold',
    role: 'member',
    status: 'inactive',
    joinDate: '2023-06-18'
  },
  {
    id: 10,
    email: 'xu.mei@email.com',
    phone: '+86 130 0102 8009',
    points: 890,
    membershipTier: 'silver',
    role: 'member',
    status: 'active',
    joinDate: '2023-08-22'
  },
  {
    id: 11,
    email: 'he.wei@email.com',
    phone: '+86 129 0113 9010',
    points: 2100,
    membershipTier: 'gold',
    role: 'member',
    status: 'active',
    joinDate: '2023-10-07'
  },
  {
    id: 12,
    email: 'gao.li@email.com',
    phone: '+86 128 0124 0011',
    points: 580,
    membershipTier: 'basic',
    role: 'member',
    status: 'active',
    joinDate: '2023-12-12'
  },
  {
    id: 13,
    email: 'lin.fang@email.com',
    phone: '+86 127 0135 1012',
    points: 1350,
    membershipTier: 'gold',
    role: 'member',
    status: 'active',
    joinDate: '2024-01-20'
  },
  {
    id: 14,
    email: 'ma.wei@email.com',
    phone: '+86 126 0146 2013',
    points: 720,
    membershipTier: 'silver',
    role: 'member',
    status: 'inactive',
    joinDate: '2024-02-15'
  },
  {
    id: 15,
    email: 'huang.li@email.com',
    phone: '+86 125 0157 3014',
    points: 2800,
    membershipTier: 'platinum',
    role: 'member',
    status: 'active',
    joinDate: '2024-03-10'
  }
];

const membershipTiers = ['basic', 'silver', 'gold', 'platinum'];
const statusOptions = ['active', 'inactive'];

function MembersPage({ onNavigate }) {
  const [members, setMembers] = useState(initialMembers);
  const [searchTerm, setSearchTerm] = useState('');
  const [editingMember, setEditingMember] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [addForm, setAddForm] = useState({
    email: '',
    phone: '',
    points: '',
    membershipTier: 'basic',
    role: 'member',
    status: 'active',
    joinDate: '',
  });

  const itemsPerPage = 10;
  const totalPages = Math.ceil(members.length / itemsPerPage);

  const filteredMembers = members.filter(member =>
    member.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
    member.phone.includes(searchTerm) ||
    member.membershipTier.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedMembers = filteredMembers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleNavClick = (item) => {
    if (onNavigate) {
      onNavigate(item);
    }
  };

  const handleEdit = (member) => {
    setEditingMember(member);
    console.log('Edit member:', member);
  };

  const handleRemove = (memberId) => {
    if (window.confirm('Are you sure you want to delete this member?')) {
      setMembers(members.filter(member => member.id !== memberId));
    }
  };

  const getMembershipTierColor = (tier) => {
    switch (tier) {
      case 'platinum': return 'platinum';
      case 'gold': return 'gold';
      case 'silver': return 'silver';
      case 'basic': return 'basic';
      default: return 'basic';
    }
  };

  const getStatusColor = (status) => {
    return status === 'active' ? 'active' : 'inactive';
  };

  const getRoleColor = (role) => {
    return role === 'admin' ? 'admin' : 'member';
  };

  // Add member form related
  const handleAddInputChange = (e) => {
    const { name, value } = e.target;
    setAddForm({ ...addForm, [name]: value });
  };

  const handleAddMember = (e) => {
    e.preventDefault();
    if (!addForm.email || !addForm.phone || !addForm.points || !addForm.joinDate) {
      alert('Please fill in all required fields');
      return;
    }
    const newMember = {
      id: Date.now(),
      ...addForm,
      points: parseInt(addForm.points, 10),
    };
    setMembers([...members, newMember]);
    setShowAddModal(false);
    setAddForm({
      email: '',
      phone: '',
      points: '',
      membershipTier: 'basic',
      role: 'member',
      status: 'active',
      joinDate: '',
    });
  };

  // Export CSV function
  const exportToCSV = () => {
    const headers = ['Email', 'Phone', 'Points', 'Membership Tier', 'Role', 'Status', 'Join Date'];
    const csvContent = [
      headers.join(','),
      ...filteredMembers.map(member => [
        member.email,
        member.phone,
        member.points,
        member.membershipTier,
        member.role,
        member.status,
        member.joinDate
      ].join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'members.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="memberspage-container">
      <nav className="sidebar">
        <div className="sidebar-title">Restaurant Management</div>
        <ul>
          {navItems.map(item => (
            <li 
              key={item} 
              className={item === 'Members' ? 'active' : ''}
              onClick={() => handleNavClick(item)}
            >
              <span className="nav-icon">{navIcons[item]}</span> {item}
            </li>
          ))}
        </ul>
      </nav>
      <main className="members-content">
        <div className="members-header">
          <h1>Member Management</h1>
          <div className="members-controls">
            <div className="search-container">
              <input
                type="text"
                placeholder="Search by email, phone or membership tier..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
            </div>
            <button className="add-member-btn" onClick={() => setShowAddModal(true)}>
              + Add Member
            </button>
          </div>
        </div>
        {/* Add member modal */}
        {showAddModal && (
          <div className="modal-overlay">
            <div className="modal">
              <h2>Add Member</h2>
              <form onSubmit={handleAddMember} className="add-member-form">
                <label>Email*<input name="email" type="email" value={addForm.email} onChange={handleAddInputChange} required /></label>
                <label>Phone Number*<input name="phone" type="text" value={addForm.phone} onChange={handleAddInputChange} required /></label>
                <label>Points*<input name="points" type="number" min="0" value={addForm.points} onChange={handleAddInputChange} required /></label>
                <label>Membership Tier
                  <select name="membershipTier" value={addForm.membershipTier} onChange={handleAddInputChange}>
                    {membershipTiers.map(tier => <option key={tier} value={tier}>{tier}</option>)}
                  </select>
                </label>
                <label>Role
                  <select name="role" value={addForm.role} onChange={handleAddInputChange}>
                    <option value="member">member</option>
                    <option value="admin">admin</option>
                  </select>
                </label>
                <label>Status
                  <select name="status" value={addForm.status} onChange={handleAddInputChange}>
                    {statusOptions.map(status => <option key={status} value={status}>{status}</option>)}
                  </select>
                </label>
                <label>Join Date*<input name="joinDate" type="date" value={addForm.joinDate} onChange={handleAddInputChange} required /></label>
                <div className="modal-actions">
                  <button type="submit" className="add-btn">Add</button>
                  <button type="button" className="cancel-btn" onClick={() => setShowAddModal(false)}>Cancel</button>
                </div>
              </form>
            </div>
          </div>
        )}
        <div className="members-table-container">
          <table className="members-table">
            <thead>
              <tr>
                <th>Email</th>
                <th>Phone Number</th>
                <th>Points</th>
                <th>Membership Tier</th>
                <th>Role</th>
                <th>Status</th>
                <th>Join Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedMembers.map(member => (
                <tr key={member.id}>
                  <td>{member.email}</td>
                  <td>{member.phone}</td>
                  <td>{member.points.toLocaleString()}</td>
                  <td>
                    <span className={`membership-badge ${getMembershipTierColor(member.membershipTier)}`}>
                      {member.membershipTier}
                    </span>
                  </td>
                  <td>
                    <span className={`role-badge ${getRoleColor(member.role)}`}>
                      {member.role}
                    </span>
                  </td>
                  <td>
                    <span className={`status-badge ${getStatusColor(member.status)}`}>
                      {member.status}
                    </span>
                  </td>
                  <td>{member.joinDate}</td>
                  <td className="actions">
                    <button 
                      className="edit-btn"
                      onClick={() => handleEdit(member)}
                    >
                      Edit
                    </button>
                    <button 
                      className="remove-btn"
                      onClick={() => handleRemove(member.id)}
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="table-footer">
            <button className="export-csv-btn" onClick={exportToCSV}>
              Export CSV
            </button>
            <div className="pagination">
              <button 
                className="pagination-btn"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                Previous
              </button>
              <span className="page-info">
                Page {currentPage} of {Math.ceil(filteredMembers.length / itemsPerPage)}
              </span>
              <button 
                className="pagination-btn"
                disabled={currentPage >= Math.ceil(filteredMembers.length / itemsPerPage)}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default MembersPage; 